<script setup>
const nuxtApp = useNuxtApp();
const { locale } = useI18n();
const { fetchPage } = useFetchAPI();
const { isSearchOpen } = useMode();

const Search = defineAsyncComponent(() => import("@/components/Search.vue"));

const menuData = computed(() => {
    return (
        nuxtApp?.payload?.data?.["fetchPage-menu"]?.[locale.value] ||
        nuxtApp?.payload?.data?.["fetchPage-menu"]?.zh
    );
});

const footerData = computed(() => {
    return (
        nuxtApp?.payload?.data?.["fetchPage-footer"]?.[locale.value] ||
        nuxtApp?.payload?.data?.["fetchPage-footer"]?.zh
    );
});

if (import.meta.client) {
    if (!menuData.value) fetchPage("menu");
    if (!footerData.value) fetchPage("footer");
}

const menuLinks = computed(() => {
    return menuData.value?.meta_box?.links ?? [];
});

const snsData = computed(() => {
    return footerData.value?.meta_box?.sns?.data ?? [];
});
</script>

<template>
    <div class="fixed left-0 top-0 h-full w-full bg-primary-orange"></div>
    <transition name="show-search-modal">
        <Search v-if="isSearchOpen" />
    </transition>
    <div class="relative bg-base-bgGrey">
        <Header :menuLinks="menuLinks" :snsData="snsData" />
        <main>
            <slot />
        </main>
    </div>
    <Footer :footerData="footerData?.meta_box" />
</template>
